import { faCheckCircle } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import React from 'react';
import { Button } from '../../flayr-components/Button/Button';
import { IconLabel } from '../../flayr-components/IconLabel/IconLabel';
import CheckCircle from '../../lib/CheckCircle/CheckCircle';
import PriceAmount from '../PriceAmount/PriceAmount';

interface ICtaBtnProps {
  showNoObligation?: boolean;
  label?: string;
  deposit?: number;
  amount?: number;
  currencySymbol?: string;
  showPrice?: boolean;
  showCancellationPolicy?: boolean;
  cancellationPolicyMessage?: React.ReactNode;
  errorMessage?: React.ReactNode;
  successMessage?: React.ReactNode;
  hideCtaBtn?: boolean;
  showCheckSuccess?: boolean;
  placeholder?: boolean;
  size?: any;
  ctaClassName?: string;
  onCtaClick?: (event?: any) => void;
  onLearnMore?: (e?: any) => void;
}

const CtaBtn: React.FC<React.PropsWithChildren<React.PropsWithChildren<ICtaBtnProps>>> = ({
  label,
  showNoObligation,
  showPrice,
  deposit,
  amount,
  currencySymbol,
  showCancellationPolicy,
  errorMessage,
  hideCtaBtn,
  showCheckSuccess,
  successMessage,
  cancellationPolicyMessage,
  onCtaClick,
  onLearnMore,
  placeholder,
  ctaClassName,
  size = 'lg',
}) => {
  const btnContent = (
    <>
      {showCheckSuccess && (
        <CheckCircle
          className="m-0 mr-3 lg:text-white"
          checkColor="lg:text-black text-white"
        />
      )}
      {label}
      {showPrice && (
        <>
          {' - '}
          <PriceAmount
            className="ml-1"
            currency={currencySymbol}
            deposit={deposit}
            amount={amount}
          />
        </>
      )}
    </>
  );

  return (
    (!placeholder && (
      <>
        {showCancellationPolicy && (
          <div
            className="px-4 py-2 mb-6 text-gray-500 bg-gray-100 rounded cursor-pointer lg:hidden"
            onClick={onLearnMore}
          >
            {cancellationPolicyMessage}
            {/* COVID Cancellation Policy -{' '} */}
            {/* <span className="underline">Learn more</span> */}
          </div>
        )}
        {!!errorMessage && (
          <div className="px-4 py-2 text-center text-danger lg:text-orange-400 lg:text-lg">
            {errorMessage}
          </div>
        )}
        {!!successMessage && (
          <div className="px-4 py-2 text-center text-success lg:text-lg">
            {successMessage}
          </div>
        )}
        <>
          <Button
            data-testid="cta-btn"
            hidden={hideCtaBtn}
            onClick={onCtaClick}
            color={(showCheckSuccess && 'secondary') || 'hot-pink'}
            block
            size={size}
            rounded="full"
            outline={showCheckSuccess}
            className={classNames('lg:hidden', ctaClassName)}
          >
            {btnContent}
          </Button>

          {!hideCtaBtn && (
            <div className="hidden lg:block">
              <Button
                data-testid="cta-btn-desktop"
                className={ctaClassName}
                color="accent"
                block
                size={size}
                onClick={onCtaClick}
              >
                {btnContent}
              </Button>
            </div>
          )}
        </>
        {showNoObligation && (
          <IconLabel
            data-testid="no-obligation"
            className={
              'flex justify-center mt-2 text-sm font-medium text-primary-1 ' +
              (ctaClassName || '')
            }
            icon={<FontAwesomeIcon icon={faCheckCircle} className="text-lg" />}
            iconContainerClassName="w-auto"
            label="No Credit card required, no obligation"
          />
        )}
      </>
    )) || (
      <div className="w-full h-10 bg-gray-700 rounded-lg animate-pulse"></div>
    )
  );
};
export default CtaBtn;
